import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {amenityProvider} from "../../../../providers/amenityProvider";
import {GenericButton} from "../../../../components/buttons/customButtons";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {roomAmenityService} from "../../../../jwt/_services/hotel/roomAmenityService";

const LinkedAmenity = props => {
    const path = `${props.path}`;

    const roomTypeState = useSelector(state => getStateByPath(state, props.path));
    const {app, domainObject: roomType} = roomTypeState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [amenity, setAmenity] = useState(null)

    const handleLinkAmenity = () => {
        if(!amenity) return;

        const requestData = {
            fbDataBase,
            item:{
                roomType: {id: roomType.id},
                amenity: {id: amenity}
            }
        }

        genericIndexedActions.save(path, roomAmenityService, requestData, resetAmenity)
    }

    const resetAmenity = () => setAmenity(null)


    return <Row className={'mb-2em'}>
        <Col sm={9}>
            <SelectGeneric
                title={'Amenidad'}
                showSpinner={false}
                initialValue={amenity}
                setExternalValue={setAmenity}
                provider={amenityProvider}
            />
        </Col>
        <Col>
            <div className={'pt-2em pull-left'}>
                <GenericButton
                    clazz={'mt-2em'}
                    style={'table'}
                    label={'Vincular'}
                    toolTip={'Agregar Actividad'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={handleLinkAmenity}
                />
            </div>
        </Col>
    </Row>
}
export default LinkedAmenity;